import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const ContactContext = createContext();

export const useContact = () => {
  return useContext(ContactContext);
};

export const ContactProvider = ({ children }) => {
  const [contactInfo, setContactInfo] = useState({
    phone: '+91 99167 10011',
    email: 'info@hbb0011realty.com',
    address: 'Prestige Falcon City, Kanakapura Rd, Anjanadri Layout, Konanakunte, Bengaluru, Karnataka 560062',
    business_hours: 'Mon - Sat: 9:00 AM - 6:00 PM'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const fetchContactInfo = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*')
        .limit(1)
        .single();
        
      if (error) {
        if (error.code !== 'PGRST116') { // not found
          console.error('Error fetching contact info:', error);
        }
      } else if (data) {
        setContactInfo({
          id: data.id,
          phone: data.phone || contactInfo.phone,
          email: data.email || contactInfo.email,
          address: data.address || contactInfo.address,
          business_hours: data.business_hours || contactInfo.business_hours
        });
      }
    } catch (err) {
      console.error('Exception fetching contact info:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContactContext.Provider value={{ contactInfo, loading, refetchContactInfo: fetchContactInfo }}>
      {children}
    </ContactContext.Provider>
  );
};
